import {Collapse, Grid, Icon, IconButton, Theme} from "@mui/material";
import {ERROR_PROPS} from "@/components/shared/type";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useStyles from "@/hooks/useStyles";

const Error = ({error, timeout}: { error: ERROR_PROPS; timeout?: number }) => {
    const [err, setErr] = useState<string | null>(null);
    const {t} = useTranslation();
    const {flexContainer, jcc, aic} = useStyles();
    const ini = error?.ini ? ` (${error.ini})` : "";
    let timeoutId: NodeJS.Timeout;
    useEffect(() => {
        clearInterval(timeoutId);
        if (error?.message) setErr(`errors.${error.message}`)
        else setErr(null)
        if(timeout) {
            timeoutId = setTimeout(() => {
                !!error?.message && setErr(null)
            }, timeout)
        }
    }, [error])

    return <Collapse className="we1" in={!!err} timeout="auto" unmountOnExit>
        <Grid container sx={{
            ...flexContainer,
            width: "100%",
            background: (theme: Theme) => theme.palette?.backgrounds?.error,
            p: 0.7,
            borderRadius: "5px",
            color: (theme: Theme) => theme.palette?.texts?.primary,
            mt: 1
        }}>
            <Grid className="df flex1 aic" sx={{pl: 1, pr: 1}}>
                <div dangerouslySetInnerHTML={{ __html: t(err as any, {...(error?.localesData ?? {}) }) + ini}} />
            </Grid>
            <Grid className="df jcc aic" sx={{width: "3rem"}}>
                <IconButton onClick={() => {
                    setErr(null)
                    clearTimeout(timeoutId);
                }}>
                    <Icon sx={{color: "#f4f4f4"}}>cancel</Icon>
                </IconButton>
            </Grid>
        </Grid>
    </Collapse>
}

export default Error;